module.exports = __webpack_public_path__ + "static/process2-ceae115a60eb084f5fc3b1b232d3670e.jpeg";